import WorkflowDesigner, {useWorkflow} from 'adminix-designer-react'
import {useState, useEffect, useCallback} from 'react'
import {colors} from '../../utils/colors'
import './index.scss'

const Designer = ({token, workflowId}) => {
    const workflow = useWorkflow({token, workflowId})
    const [iframeHeight, setIframeHeight] = useState(0)

    const calculateIframeHeight = useCallback(() => {
        const contentHeight = document.getElementById('designer-iframe').clientHeight

        setIframeHeight(contentHeight - 10)
    }, [setIframeHeight])

    useEffect(() => calculateIframeHeight(), [calculateIframeHeight])

    useEffect(() => {
        const onResize = () => calculateIframeHeight()

        window.addEventListener('resize', onResize)

        return () => window.removeEventListener('resize', onResize)
    }, [calculateIframeHeight])

    return (
        <WorkflowDesigner
            workflow={workflow}
            width="100%"
            height={iframeHeight}
            colorPrimary={colors.colorBlue}
            fontSize="14"
            disableMessages={false}
            disableActions={false}
        />
    )
}

export default Designer
